import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
  theme,
} from '@bechtel/gds';
import { t, Trans } from '@lingui/macro';
import { CreateFitupRequestErrorProps } from './types';
import { CreateFitupRequestsError, CreateFitupRequestError, ReassignFitupRequestError } from '@bechtel/types';
import { map } from 'lodash';
import { ApolloError } from '@apollo/client';

const getErrorMessage = (error: CreateFitupRequestError | ReassignFitupRequestError) => {
  switch (error) {
    case CreateFitupRequestError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case CreateFitupRequestError.COMMODITY_ALREADY_CLAIMED:
      return <Trans>Commodity already claimed.</Trans>;
    case CreateFitupRequestError.COMMODITY_ALREADY_APPROVED:
      return <Trans>Commodity already approved.</Trans>;
    case CreateFitupRequestError.CREATE_FITUP_REQUEST_ERRORED:
      return <Trans>Create fitup request error.</Trans>;
    case CreateFitupRequestError.INVALID_COMMODITY_ID:
      return <Trans>Invalid commodity id.</Trans>;
    case CreateFitupRequestError.FITUP_ALREADY_REQUESTED:
      return <Trans>Fitup already requested.</Trans>;
    case ReassignFitupRequestError.REASSIGN_FITUP_REQUEST_ERRORED:
      return <Trans>Reassign fitup request error.</Trans>;
    case ReassignFitupRequestError.FITUP_REQUEST_NOT_FOUND:
      return <Trans>Fitup request not found.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const CreateFitupRequestErrorModal: FC<CreateFitupRequestErrorProps> = ({ errors, close, isReassign }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '450px', maxHeight: '450px' }}>
      <ModalHeader title={isReassign ? t`Reassign Weld Error` : t`Create Fitup Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box pb={{ sm: '500' }} flexGrow={{ sm: 1 }} flexDirection={{ sm: 'column' }} css={{ minHeight: '150px' }}>
          {errors instanceof ApolloError && (
            <Box p={{ sm: '500' }}>
              <Text>
                <Trans>Network error has occured.Please close button and try again.</Trans>
              </Text>
            </Box>
          )}
          {errors instanceof Array &&
            map(errors, (error: CreateFitupRequestsError, index) => {
              return (
                error && (
                  <Box
                    key={index}
                    css={{
                      borderBottom: errors?.length > 1 ? `1px solid ${theme.colors.grey[300]}` : '',
                      width: '100%',
                    }}
                  >
                    <Box justifyContent={{ sm: 'space-between' }} p={{ sm: '500' }}>
                      {error?.weld && (
                        <Box mr={{ sm: '200' }}>
                          <Text size="500" weight="600">
                            {error?.weld.tag}-
                          </Text>
                        </Box>
                      )}

                      <Box ml={{ sm: '200' }}>
                        <Text>{getErrorMessage(error?.errorCode)}</Text>
                      </Box>
                    </Box>
                  </Box>
                )
              );
            })}
          {!(errors instanceof ApolloError) && !(errors instanceof Array) && (
            <Box p={{ sm: '500' }}>
              <Text>{getErrorMessage(errors)}</Text>
            </Box>
          )}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button
              appearance={ButtonAppearance.SECONDARY}
              onClick={close}
              css={`
                padding-left: ${({ theme }) => theme.spacings['600']};
                padding-right: ${({ theme }) => theme.spacings['600']};
              `}
            >
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
